import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import DPPCard from './DPPCard';
import useEduLeaderboard from './useEduLeaderboard';

const Wrapper = styled.div`
  grid-column: span 18;
  margin-bottom: ${Spacings.SPACING_20B};

  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const Subtext = styled(P1)`
  margin-top: ${Spacings.SPACING_1B};
  color: var(--color-text-secondary);
`;

const DPPCardContainer = styled.div`
  display: grid;
  margin-top: ${Spacings.SPACING_6B};
  grid-template-columns: repeat(3, 272px);
  grid-gap: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
    grid-gap: ${Spacings.SPACING_3B};
  }
`;

const EducatorLeaderboard = () => {
  const { data, isValidating, isError } = useEduLeaderboard();

  if (isValidating || isError || data?.educators?.length < 3) {
    return null;
  }

  return (
    <Wrapper>
      <div>
        <H4>Top practices by educators</H4>
        <Subtext>
          Learners loved attempting practices by these educators
        </Subtext>
      </div>
      <DPPCardContainer>
        {data.educators.map((educatorInfo) => {
          return (
            <DPPCard
              key={educatorInfo.educatorDetailsJson.uid}
              info={educatorInfo}
            />
          );
        })}
      </DPPCardContainer>
    </Wrapper>
  );
};

export default EducatorLeaderboard;
